import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-tasbeeh-counter',
  imports: [PagePlaceholderComponent],
  templateUrl: './tasbeeh-counter.component.html',
  styleUrl: './tasbeeh-counter.component.scss'
})
export class TasbeehCounterComponent {
  protected readonly icon = '📿';
  protected readonly pageTitle = 'pages.tasbeeh_counter.title';
  protected readonly subtitle = 'pages.tasbeeh_counter.subtitle';
}
